import axios from 'axios'
import { REACT_APP_PERITADOR_API } from 'cfgCommon/config';

export const generateExcelManangement = async (fromDate, toDate, isAsofix) => {
  
  const res = await axios(
    `${REACT_APP_PERITADOR_API}/takingCarManagment/generateExcel?fechaOperacionDesde=${fromDate}&fechaOperacionHasta=${toDate}&isAsofix=${isAsofix}`,
    {
      method: 'GET',
      responseType: 'blob',
      timeout: 300000 // 5 minutos
    }
  )

  return res.data
}
